import apiFetch from '../apiFetch'

export default function (values, token) {
  return apiFetch({endPoint: `ValidacionMateriaPrima/eliminarValidacionMateriaPrimaSeleccion`, method: 'POST', body: values, token: token})
}